import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Option } from 'models/OptionModel';

const OptionForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.OPTION, Code.Form.Name.OPTION];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [modeOptions, setModeOptions] = Hooks.Form.Options();
  const [actionOptions, setActionOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Option>({});
  
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.API(Code.File.GROUP, Code.Option.Common.SELECT, setModeOptions, setError,true);
    Files.Json.Http(Code.File.ACTION, Code.Option.Common.NA, setActionOptions, setError);
   
    API.Data.GetByKeyId<Option>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.option_active); 
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
      }})
      setLoading(false);
  }, []);

  useEffect(() => {
    console.log("formData---->",formData);
  }, [formData]);

  const onSubmit = (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;

    const finalData = Utility.Sanitize.FormData({
      ...formData,
      company_id: Utility.Storage.CompanyId(),
      location_id: Utility.Storage.LocationId(),
      user_id: Utility.Storage.UserId(),
    });

    API.Data.Save(formName, keyId, finalData, setMessage)

  };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} formName={formName} formId={formId} Privilege={Privilege} />
          <Control.Tab.Header titles={["Details"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
 
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Box>
                <Field.FilterSelect id={Name.Common.GroupId} value={formData.group_id} title={Title.Group} options={modeOptions} setFormData={setFormData} require={true} />
                <Field.Text id={Name.Option.Name} value={formData.option_name} title={Title.Title} onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true} />
                <Field.Area id={Name.Option.Comment} value={formData.option_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
                <Field.FilterSelect id={Name.Common.ActionId} value={formData.action_id} title={Title.Action} options={actionOptions} setFormData={setFormData} />
              </Control.Box>
              <Control.Row>
                <Field.Amount id={Name.Option.Value} value={formData.option_value} title={Title.Rate} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} />
                <Field.Color id={Name.Option.Color} value={formData.option_color} title={Title.Color} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
            </Control.Tab.Content>

          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default OptionForm;